import type { GTMEventReturnType, GTMRemoveLocationType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMOverviewFilterRemoveModelReturnType extends GTMEventReturnType {
    filter_label: string;
    filter_group: string;
    remove_location: GTMRemoveLocationType;
}

export interface GTMOverviewFilterRemoveModelData {
    label: string;
    category: string;
    location?: GTMRemoveLocationType;
}

export default class GTMOverviewFilterRemoveModel extends GTMBaseModel {
    public static parseToGTMData({
        label,
        category,
        location = 'zijbalk'
    }: GTMOverviewFilterRemoveModelData): GTMOverviewFilterRemoveModelReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'overview_filter_remove',
            filter_label: label,
            filter_group: category,
            remove_location: location
        };
    }
}
